export default __webpack_public_path__ + "static/media/bannerFeiraoCarnaval2.313fd4c4.png";